





















import { FAQWebSiteService } from '@/administration/src/services/FAQWebSiteService';
import { Component, Vue } from 'vue-property-decorator';

const service = new FAQWebSiteService();

interface IFaqItemModel {
  answer: string;
  id: number;
  question: string;
}

@Component({})
export default class FaqContent extends Vue {
  private loading = false;

  private items: IFaqItemModel[] = [];

  async getFaq(): Promise<void> {
    this.loading = true;
    try {
      const data = await service.getPublicFaq({ pageSize: 999, page: 1 });
      console.log(data);
      this.items = data.data;
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    this.getFaq();
  }
}
